export default __webpack_public_path__ + "static/media/Betterlove.8c79c6e4.ttf";